import React from "react";
import { Strings } from "src/constants";
import { Input } from "../input";
import Modal from "../modal/modal";

interface ILabelEditPopupProps {
  isShow: boolean;
  handleShow: (isShow: boolean) => void;
  initialLabel: string;
  onChange: (newLabel: string) => void;
}

interface ILabelEditPopupState {
  labelValue: string;
}

class LabelEditPopup extends React.Component<ILabelEditPopupProps, ILabelEditPopupState> {
  constructor(props: ILabelEditPopupProps) {
    super(props);
    this.state = {
      labelValue: props.initialLabel || "",
    };
  }

  componentDidUpdate(prevProps: ILabelEditPopupProps) {
    if (prevProps.initialLabel !== this.props.initialLabel) {
      this.setState({ labelValue: this.props.initialLabel || "" });
    }
  }

  handleSave = () => {
    this.props.onChange(this.state.labelValue);
    this.props.handleShow(false);
  };

  render() {
    return (
      <Modal
        id="imageType"
        isShow={this.props.isShow}
        onClose={() => {
          this.props.handleShow(false);
        }}
        className="label-edit-popup flexible"
        footerChildren={
          <React.Fragment>
            <div className="d-flex justify-center">
              <button type="button" className="btn btn-secondary mr10" onClick={() => this.props.handleShow(false)}>
                キャンセルする
              </button>
              <button type="button" className="btn btn-primary" onClick={this.handleSave}>
                変更する
              </button>
            </div>
          </React.Fragment>
        }
      >
        <h4 className="text_bold mb20">{Strings.TITLE_INPUT}</h4>
        <div className="input" style={{ width: "400px" }}>
          <Input
            inputClassName="form-control"
            type="text"
            value={this.state.labelValue}
            maxLength={20}
            onChange={(value) => {
              this.setState({ labelValue: value });
            }}
          />
          <div className="text_right">
            <span>{this.state.labelValue.length}/20</span>
          </div>
        </div>
      </Modal>
    );
  }
}

export default LabelEditPopup;
